module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a-layout-sider', {
    class: [_vm.theme, 'sider', _vm.isMobile ? null : 'shadow', _vm.fixSiderbar ? 'ant-fixed-sidemenu' : null],
    attrs: {
      "width": "256px",
      "collapsible": _vm.collapsible,
      "trigger": null
    },
    model: {
      value: (_vm.collapsed),
      callback: function($$v) {
        _vm.collapsed = $$v
      },
      expression: "collapsed"
    }
  }, [_c('div', {
    class: ['logo', _vm.theme]
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [(this.$store.state.setting.theme === 'dark') ? _c('img', {
    attrs: {
      "height": "32",
      "src": _vm.logoUrlDark,
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (this.$store.state.setting.theme === 'light') ? _c('img', {
    attrs: {
      "height": "32",
      "src": _vm.logoUrlLight,
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "animated fadeIn"
  }, [_vm._v(_vm._s(_vm.systemName))])])], 1), _vm._v(" "), _c('i-menu', {
    attrs: {
      "theme": _vm.theme,
      "collapsed": _vm.collapsed,
      "menuData": _vm.menuData
    },
    on: {
      "select": _vm.onSelect
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-4d33f62d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/SiderMenu.vue
// module id = krAn
// module chunks = 273